import { Product } from 'framework/products'
import { EcommerceService } from 'services'
import type { ShippingZipcode } from '.'

type SellersProducts = Record<string, Product[]>;

const sellersProducts: SellersProducts = {/* dados do seu objeto */};

class ShippingService extends EcommerceService {
  onlyUnique = (value: string, index: number, self: any) => {
    return self.indexOf(value) === index
  }

  calculate(items: any[], zipcode: ShippingZipcode, forceExperience: boolean = false) {
    let amount = 0
    let countExperiences = 0
    const sellers: any[] = []
    items.map((item) => {
      sellers.push(item.seller.id)
      amount += item.itemTotal

      if (item.type === 'experiencia') {
        countExperiences += 1
      }
    })
    const payload = {
      farmers: sellers.filter(this.onlyUnique),
      amount,
      zipcode,
      is_experience: countExperiences === items.length || forceExperience,
    }

    const url = '/shipping/calculate'
    const req = this.setUrl(url).post(payload)
    return req
  }

  calculateV2(items: any[], zipcode: ShippingZipcode, forceExperience: boolean = false) {
    console.log("items", items)
    let amount = 0;
    let countExperiences = 0;
    const sellers: any[] = [];
    items.map((item) => {
      sellers.push(item.seller.id);
      amount += item.itemTotal;

      if (item.type === 'experiencia') {
        countExperiences += 1;
      }
    });

    const sellersIds = items.map((item) => item.seller?.id);
    const filteredSellersIds = sellersIds.filter((item, index) => sellersIds.indexOf(item) === index);

    const sellersProducts: Record<string, any> = {};

    filteredSellersIds.forEach((item) => {
      const filteredProducts = items.filter((product) => item === product.seller?.id);
      sellersProducts[item] = filteredProducts;
    });

    const data: Record<string, { id: string; qty: number }[]> = {};  // Explicitly typed `data`

    Object.keys(sellersProducts).forEach((item) => {
      const productsInfo = sellersProducts[item].map((product: any) => ({
        id: product?.id,
        qty: product.quantity,
      }));
      data[item] = productsInfo;
    });

    const payload = {
      data,
      zipcode,
      is_experience: countExperiences === items.length || forceExperience,
    };

    const url = '/shipping/v2/calculate';
    const req = this.setUrl(url).post(payload);
    return req;
  }

  calculateProductFreight(product: Product, zipcode: ShippingZipcode) {
    const payload = {
      farmers: [product.seller.id],
      amount: product.price.sell,
      zipcode,
    }

    const url = '/shipping/calculate'
    const req = this.setUrl(url).post(payload)
    return req
  }

  calculateProductFreightV2(product: Product, zipcode: ShippingZipcode, quantity: number, forceExperience: boolean = false) {
    // const payload = {
    //   farmers: [product.seller.id],
    //   amount: product.price.sell,
    //   zipcode,
    // }

    // const url = '/shipping/calculate'
    // const req = this.setUrl(url).post(payload)
    // return req

    // const payload = {
    //   farmers: sellers.filter(this.onlyUnique),
    //   amount,
    //   zipcode,
    //   is_experience: countExperiences === items.length || forceExperience,
    // }

    const data = {};

    const payload = {
      // farmers: sellers.filter(this.onlyUnique),
      // amount,
      data: { [product.seller.id]: [{ "id": product.id, "qty": quantity }] },
      zipcode,
      // is_experience: countExperiences === items.length || forceExperience,
    }

    const url = '/shipping/v2/calculate'
    const req = this.setUrl(url).post(payload)
    return req
  }
}

export default ShippingService
